import { Injectable } from '@angular/core';
import {GeneralService} from "../../../services/general-delete.service";
import {HttpClient} from "@angular/common/http";
import {StorageService} from "front-common-toolkits";

@Injectable({
  providedIn: 'root'
})
export class TenantRoleService extends GeneralService {

  constructor(
    public http: HttpClient,
    private storageService: StorageService
  ) {
    super(http);

    this.setModelPath('/ten/role');
  }
  getTenRoleInfo(pageNumber,pageSize=10) {
    let params = {
      pageNumber: pageNumber,
      pageSize: pageSize,
      orderProperty :'createTime',
      orderType: 'DESC',
      tenantId:0
    }
    return this.http.get(this.httpBase + '/ten/role',{params:params})
  }
}
